import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Drawer } from '@root/shared/ui-kit'

import { CurrencyCreateForm } from './currency-create-form'

import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'onOpenChange' | 'open'> & {}

export const CreateCurrencyFormDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      title={t('currency.create-token')}
    >
      <Content>
        <CurrencyCreateForm onDone={() => onOpenChange?.(false)} />
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  max-height: var(--max-drawer-height);
`

const Content = styled.div`
  padding-inline: 12px;
  padding-block: 0 32px;
  overflow: auto;
`
